<template>
  <main class="main">
    <div class="anim-wrap" :class="{ loading: loading }">
      <div class="container" v-if="selectedGroupData">
        <div class="row page-nav">
          <div class="col-md-8 hidden-sm">
            <nav class="breadcrumbs">
              <ol class="breadcrumb">
                <li>
                  <router-link to="/" class="link-item">Dashboard</router-link>
                </li>
                <li>
                  {{ selectedGroupData.groupName }}
                </li>
              </ol>
            </nav>
          </div>
          <div class="col-md-4 text-md-right">
            <router-link to="/" class="link-item"
              ><font-awesome-icon icon="angle-left" /> Back to
              Dashboard</router-link
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div
              :id="user.id"
              v-bind:key="user.id"
              v-for="user in groupData"
              class="panel panel-list panel-user report-user"
            >
              <div class="info">
                <h5>{{ user.firstName }} {{ user.lastName }}</h5>
              </div>
              <div class="persona" v-if="user.personality">
                <h6 title="Openness" :title="personas[user.personality.persona].description" v-tippy="{ theme: 'navy' }">{{ personas[user.personality.persona].title }}</h6>
                <div class="scores">
                  <span class="ope" title="Openness" v-tippy="{ theme: 'navy' }">{{ user.personality.scores.ope }}</span>
                  <span class="con" title="Conscientiousness" v-tippy="{ theme: 'navy' }">{{ user.personality.scores.con }}</span>
                  <span class="ext" title="Extraversion" v-tippy="{ theme: 'navy' }">{{ user.personality.scores.ext }}</span>
                  <span class="agr" title="Agreeableness" v-tippy="{ theme: 'navy' }">{{ user.personality.scores.agr }}</span>
                  <span class="neu" title="Neuroticism" v-tippy="{ theme: 'navy' }">{{ user.personality.scores.neu }}</span>
                </div>
              </div>
              <div class="riasec" v-if="user.pathways && user.pathways.riasec">
                <div
                  v-bind:key="item.key"
                  v-for="(item, index) in orderScores(user.pathways.riasec)"
                  class="area"
                  :class="item.area"
                  :title="item.description" v-tippy="{ theme: 'navy' }"
                >
                {{item.area.substring(0, 1)}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            v-bind:key="persona.key"
            v-for="(persona, index) in groupPersonas"
            class="col-md-4"
          >
            <ReportPersonaCard :persona="index" :personaData="persona" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h3 style="margin-bottom: 10px;">Openness</h3>
            <div class="content-panel padded">
              <div class="chart-wrapper">
                <dot-plot
                  class="chart-sizer"
                  :chartdata="chartData"
                  :options="chartOptions"
                ></dot-plot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import { db } from "../main.js";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapState } from "vuex";
import DotPlot from "@/components/DotPlot.js";
import { personas, reporting } from "@/assets/static.js";

import ReportPersonaCard from "@/components/ReportPersonaCard";

var _ = require("lodash");

export default {
  name: "groupreport",
  components: { DotPlot, ReportPersonaCard, personas, reporting },
  data() {
    return {
      groupData: null,
      personas: personas,
      reporting: reporting,
      groupPersonas: null,
      chartData: null,
      chartOptions: null,
      staticData: [
        {
          gewgewgew: {
            firstName: "Jacob",
            lastName: "Peterson",
            personality: {
              scores: {
                agr: 52,
                con: 67,
                ext: 33,
                neu: 7,
                ope: 24,
              },
            },
          },
          wgeewhg: {
            firstName: "Jade",
            lastName: "Smith",
            personality: {
              scores: {
                agr: 22,
                con: 44,
                ext: 85,
                neu: 32,
                ope: 14,
              },
            },
          },
          hewhewhew: {
            firstName: "Rachel",
            lastName: "Mitchelson",
            personality: {
              scores: {
                agr: 17,
                con: 38,
                ext: 75,
                neu: 90,
                ope: 26,
              },
            },
          },
        },
      ],
      id: null,
      loading: false,
      incognito: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["organisationData"]),
    ...mapState(["groupsData"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getGroupsData() {
      return this.groupsData ? this.groupsData : "";
    },
    getOrganisationData() {
      return this.organisationData ? this.organisationData : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    selectedGroupData() {
      if (this.getGroupsData) {
        return this.getGroupsData.find((o) => o.id === this.id);
      } else {
        return false;
      }
    },

    dotPlotOpenness() {
      return;
    },
    orderedUsers: function() {
      return _.orderBy(
        this.selectedGroupData.users,
        "createDate.seconds"
      ).reverse();
    },
  },
  mounted() {
    this.fillData();
    this.id = this.$route.query.group;
    this.getGroupReport();
  },
  methods: {
    orderScores(scores) {
      let orderedScores = JSON.parse(JSON.stringify(scores));
      orderedScores.sort(function(b, a) {
        return a.score - b.score;
      });
      orderedScores = orderedScores.slice(0, 3);
      return orderedScores;
    },
    getGroupReport() {
      let groupReport = db
        .collection("groupReports")
        .doc(this.selectedGroupData.id);

      groupReport
        .get()
        .then((doc) => {
          if (doc.exists) {
            let testData = doc.data();
            this.groupData = testData.testData;
            this.countPersonas();
          } else {
            this.generateGroupReport();
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    generateGroupReport() {
      let createGroupReport = firebase
        .functions()
        .httpsCallable("createGroupReport");

      createGroupReport({
        groupId: this.id,
        organisationId: this.getOrganisationData.id,
      })
        .then((result) => {
          this.groupData = result.data.testData;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    countPersonas() {
      let personas = {};
      this.groupData.forEach((element) => {
        if (element.personality) {
          let userData = {
            id: element.id,
            firstName: element.firstName,
            lastName: element.lastName,
          };
          if (personas[element.personality.persona]) {
            personas[element.personality.persona].push(userData);
          } else {
            personas[element.personality.persona] = [];
            personas[element.personality.persona].push(userData);
          }
        }
      });
      this.groupPersonas = personas;
    },
    transformData() {
      let data = [
        25,
        25,
        42,
        74,
        86,
        32,
        74,
        99,
        66,
        3,
        13,
        17,
        50,
        55,
        58,
        77,
        25,
        42,
        50,
        50,
        55,
        68,
        88,
      ];
      const dataArray = [];
      data.forEach((value) => {
        let stat = null;
        if (dataArray.some((e) => e.x === value)) {
          stat = { x: value, y: 8 };
        } else {
          stat = { x: value, y: 0 };
        }
        dataArray.push(stat);
      });
      console.log(dataArray);
      return dataArray;
    },
    fillData() {
      let transformedData = this.transformData();
      this.chartData = {
        labels: [""],
        datasets: [
          {
            label: "Openness",
            backgroundColor: "#3D98D2",
            data: transformedData,
          },
        ],
      };
      this.chartOptions = {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              type: "linear",
              position: "bottom",
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                min: -5,
                max: 50,
              },
            },
          ],
        },
        showLines: false,
        elements: {
          point: {
            radius: 10,
            hoverRadius: 15,
          },
        },
      };
    },
    timestampToTimeSince(timestamp) {
      let time = this.$timeSince(new Date(timestamp.seconds * 1000));
      return time;
    },
    transformName(user) {
      if (this.incognito || user.firstName === "") {
        let truncated = user.id.toUpperCase();
        let name = "User " + truncated.substring(0, 5);
        return name;
      } else {
        return user.firstName + " " + user.lastName;
      }
    },
  },
};
</script>
